module.exports = __webpack_public_path__ + "media/images/StanfordAlumni_Logo-4f070598ff98ffe84bd18949ca98ac39.png";